<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        src="img/avatars/6.jpg"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />
    </template>\
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header>
      <b-dropdown-item><i class="fa fa-user" /> Profilo</b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item @click="logout"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import { Auth } from 'aws-amplify'
export default {
  name: 'HeaderAccount',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { 

     }
  },
  methods: {
      logout() {
          console.log("logout!");
          Auth.signOut().then(data => {
            this.$store.commit('setLoggedUser',null);
            this.$router.push({name: 'Login'});
          });
          
      }
  }
}
</script>
